export function getEnumValues<K extends string, V>(e: Record<K, V>): V[] {
  const keys = Object.keys(e);
  const values = Object.values<V>(e);

  if (values.some((value) => !keys.includes(`${value}`))) {
    return values;
  }

  const valueValues = values.slice(values.length / 2);
  const valueKeys = keys.slice(0, values.length / 2);

  if (valueValues.every((value) => valueKeys.includes(`${value}`))) {
    return valueValues;
  }

  return values;
}
